import { createCrudSlice } from 'app/createCrudSlice';
import { userService } from 'services/userService';

const { reducer, thunks } = createCrudSlice({ name: 'users', service: userService });

export const {
  fetch: fetchUsers,
  create: createUser,
  update: updateUser,
  remove: deleteUser,
} = thunks;

export default reducer;
